import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { AppBar, Button } from '@material-ui/core';

const headerStyle = {
  title: css`
    font-size: 17px;
    font-weight: 400;
    padding-left: 33px;
  `,
};

export const HeaderLogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const HeaderContainer = styled(AppBar)`
  display: flex;
  flex-direction: row !important;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
`;

export const HeaderButton = styled(Button)`
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #fff !important;
  transition: opacity 0.2s !important;

  &:hover {
    opacity: 0.8;
  }

  svg {
    width: 20px;
    height: 20px;
    padding: 0 4px 0 0;
  }
`;

export const HeaderLogoutButton = styled(HeaderButton)`
  color: #219ce6 !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  font-weight: bold !important;
`;

export default headerStyle;
